
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13262',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13262",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.815",
  "client-types": "static-1.498",
  "data-fetching-client": "static-1.9973",
  "foundations-components": "static-1.8513",
  "foundations-components-legacy": "static-1.1538",
  "foundations-theming": "static-1.4791",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8349",
  "hub-http-shared-msw-handlers": "static-1.10639",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11805",
  "I18n": "static-7.1676",
  "jasmine-runner": "static-1.6767",
  "marketplace-discovery-studio-lib": "static-1.655",
  "marketplace-storefront-base": "static-1.13325",
  "quartz": "static-1.7475",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1.17037",
  "reactive-variable-buffer-atom": "static-1.3172",
  "reporting-testing-lib": "static-1.10795",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12841",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7644",
  "ui-addon-i18n": "static-1.11463",
  "ui-addon-react-router-dom": "static-1.9851",
  "unified-auth": "static-1.938",
  "unified-auth-core-lib": "static-1.1220",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8418",
  "hub-http": "static-1.6530",
  "integrations-lib": "static-1.17066",
  "marketplace-ui-common": "static-1.20758",
  "marketplace-ui-install": "static-1.744",
  "property-management-iframe": "static-1.14154",
  "quartz-config": "static-1.1253",
  "quartz-core": "static-1.6694",
  "quartz-routing": "static-1.905",
  "quick-fetch": "static-1.4139",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.4982",
  "ts-schema": "static-1.4304",
  "ui-universal-auth": "static-1.9424",
  "UIComponents": "static-3.8751",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3631",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3752",
  "quartz-webpack": "static-1.3699",
  "bend-plugin-quartz-routing": "static-1.553",
  "ai-components-ui-library": "static-1.9744",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5201",
  "pulse": "static-1.945",
  "react-codemirror": "static-1.10957",
  "ui-extensions-preview-lib": "static-1.628",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4782",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2507",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9740",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.73",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5566",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.503",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2678",
  "ui-fonts": "static-1.1067",
  "ui-images": "static-2.1252",
  "bend-plugin-foundations-theming": "static-1.3274",
  "foundations-theming-base": "static-1.3776",
  "stylex": "static-1.41",
  "HeadJS": "static-2.798",
  "hs-test-utils-bend-plugin": "static-1.3460",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4629",
  "ui-addon-video-player": "static-1.9020",
  "ai-rendering-library": "static-1.11118",
  "chirp-fetch": "static-1.2212",
  "connections-embed-lib": "static-1.1529",
  "copilot-toolkit": "static-1.11865",
  "feedback-loader": "static-1.29829",
  "laboratory-lib": "static-3.7470",
  "marketplace-embed": "static-1.22939",
  "marketplace-ui-details": "static-1.10653",
  "marketplace-ui-reviews": "static-1.20713",
  "marketplace-ui-tracking": "static-1.14928",
  "sanitize-text": "static-1.8472",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7210",
  "quartz-head": "static-1.1140",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4972",
  "immer": "static-1.101",
  "immerable": "static-1.4464",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2699",
  "reporting-data": "static-1.68862",
  "cssUtils": "static-1.938",
  "flux-actions": "static-1.369",
  "react-colorpicker": "static-2.10533",
  "react-dnd-compat": "static-1.4932",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10687",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.685",
  "marketplace-ui-apps-core": "static-1.19290",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4825",
  "foundations-components-test-utils": "static-1.5996",
  "quartz-i18n": "static-1.1150",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.484",
  "ads-unified-auth-lib": "static-1.1450",
  "generic-oauth-auth-lib": "static-1.66",
  "google-sheets-integration-lib": "static-1.1052",
  "microsoft-drive-auth-lib": "static-1.168",
  "surveymonkey-integration-lib": "static-1.510",
  "slack-ui-library": "static-1.10714",
  "fsm": "static-1.4066",
  "customer-data-objects": "static-1.8009",
  "property-translator": "static-1.5711",
  "hs-locale-management": "static-1.304",
  "frontend-preferences-client": "static-1.8238",
  "hs-promise-utils": "static-1.5911",
  "hubspot-apollo-client": "static-1.5194",
  "integrations-error-boundary-lib": "static-1.14481",
  "integrations-tracking-lib": "static-1.5925",
  "native-integrations-shared-strings": "static-1.8093",
  "sanitize": "static-1.4788",
  "superstore": "static-1.5074",
  "ui-shepherd-react": "static-3.10586",
  "ai-settings-ui-library": "static-1.8363",
  "hub-http-janus": "static-1.883",
  "hubspotter-http": "static-1.4872",
  "immutable-less": "static-1.4966",
  "marketplace-ui-client-types": "static-1.18165",
  "nav-meta": "static-1.30497",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18401",
  "ui-product-approvals-common": "static-1.1102",
  "ai-studio-lib": "static-1.12453",
  "hubspot-prosemirror": "static-1.18991",
  "integrations-reconnect-lib": "static-1.502",
  "ui-addon-iframeable": "static-1.9394",
  "ui-addon-integrations-directory-panel": "static-2.8343",
  "ui-product-approvals": "static-1.29207",
  "ui-tool-access": "static-1.10470",
  "inbound-db-properties-service-client": "static-1.4064",
  "property-management-common": "static-1.6442",
  "opentelemetry-fe-types": "static-1.87",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.578",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.462",
  "quartz-auth": "static-1.1150",
  "quartz-test": "static-1.1150",
  "quartz-tracking": "static-1.854",
  "trellis-components": "static-1.2697",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.392",
  "HubStyle": "static-2.12112",
  "bender-build-tools": "static-1.3452",
  "chatspot-core": "static-1.23085",
  "customer-data-objects-ui-components": "static-1.13346",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.448",
  "batch-promise": "static-1.1861",
  "event-emitter": "static-1.1269",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5769",
  "magpie-types": "static-1.5229",
  "stylex-utils": "static-1.143",
  "trellis-theming": "static-1.1290",
  "avatar-components": "static-1.2798",
  "breeze-engine-core": "static-1.1051",
  "breeze-onboarding-components": "static-1.755",
  "customer-data-filters-ui": "static-1.40966",
  "customer-data-reference-ui-components": "static-1.13494",
  "embedded-academy-lib": "static-1.15555",
  "ExportDialog": "static-6.10694",
  "global-styles-ai-lib": "static-1.162",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.642",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42074",
  "reporting-snowflake": "static-1.57479",
  "reporting-ui-components": "static-2.66132",
  "reporting-visualizations": "static-1.60937",
  "trial-components-library": "static-1.14125",
  "ui-addon-teams": "static-1.21923",
  "upgrade-components-lib": "static-1.536",
  "navigation-components": "static-1.18860",
  "breeze-engine-lib": "static-1.1773",
  "simple-logging-lib": "static-1.3368",
  "fail-safe": "static-1.270",
  "app-governance-lib": "static-1.2414",
  "developer-experience-shared-components": "static-1.10856",
  "purchase-motions-components": "static-1.6381",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10296",
  "autolinker": "static-3.11",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4018",
  "reference-resolvers": "static-1.8497",
  "sassPrefix": "static-1.207",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4234",
  "hubspot-apollo-cache": "static-1.653",
  "universal-page-editor-lib": "static-1.3325",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3542",
  "atom": "static-1.5403",
  "merchandise-lib": "static-1.278",
  "salesImages": "static-1.579",
  "ui-addon-draggable": "static-3.5076",
  "content-assistance-lib": "static-1.8216",
  "content-media-capture": "static-1.5465",
  "customer-data-ui-utilities": "static-1.10148",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24525",
  "growth-payments-core": "static-1.26207",
  "knowledge-content-types": "static-1.8660",
  "PatternValidationJS": "static-1.3209",
  "payment-link-components": "static-1.24192",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20323",
  "ui-addon-emoji-picker": "static-1.10201",
  "ui-business-units-lib": "static-1.9406",
  "video-components-external": "static-1.12169",
  "video-data-lib": "static-1.35827",
  "navigation-messaging": "static-1.8187",
  "collaboration-sidebar": "static-1.58745",
  "crm-properties-common-lib": "static-1.6206",
  "customer-data-properties": "static-1.52634",
  "framework-data-schema-resolvers": "static-1.7208",
  "property-value-citations": "static-1.3248",
  "reference-resolvers-lite": "static-1.8419",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10637",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1034",
  "breeze-artifacts-sdk": "static-1.381",
  "onboarding-journeys-lib": "static-1.943",
  "onboarding-scopes": "static-1.6768",
  "conversations-skeleton-state": "static-1.7564",
  "crm-message-bus": "static-1.43787",
  "customer-data-filters-ui-msw-helpers": "static-1.23401",
  "events-data-lib": "static-1.563",
  "FormUrlGenerator": "static-2.5043",
  "framework-builder-read-service-client": "static-1.4231",
  "hs-resources": "static-1.507",
  "multi-account-reference-resolvers": "static-1.1322",
  "onboarding-tours": "static-1.17132",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14488",
  "academy-common-lib": "static-1.15015",
  "ContentUtils": "static-1.69146",
  "dashboard-lib": "static-1.82873",
  "getting-started-shared-tasks": "static-1.19266",
  "hubspot-prosemirror-plugins": "static-1.18983",
  "share-with-third-party-component-lib": "static-1.9023",
  "ui-asset-management-lib": "static-1.11414",
  "user-context": "static-1.5436",
  "reporting-plugins": "static-1.10769",
  "reporting-reports": "static-1.68539",
  "hubs-service-types": "static-1.1576",
  "purchase-motions-api": "static-1.6384",
  "signup-constants": "static-1.19649",
  "nest": "static-1.552",
  "breeze-engine-chat-components": "static-1.751",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.221",
  "framework-listing-lib": "static-2.29519",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31460",
  "apps-service-types": "static-1.4056",
  "oauth-service-types": "static-1.4552",
  "signup-ui-url-generator": "static-2.8377",
  "onboarding-tours-client": "static-1.5347",
  "one-click-checkout": "static-1.431",
  "platform-infra-nav-components": "static-1.7902",
  "subscription-experience-data-types": "static-1.15256",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10121",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29330",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4742",
  "seat-types-lib": "static-1.754",
  "ui-addon-opt": "static-4.8680",
  "commerce-tours-lib": "static-1.6636",
  "growth-onboarding-reliability": "static-1.5397",
  "sales-checkout-service-client": "static-1.3846",
  "data-token-picker": "static-1.16907",
  "FileManagerLib": "static-1.40165",
  "content-media-composition-data-lib": "static-1.13269",
  "content-media-compositions": "static-2.17276",
  "media-bridge-lib": "static-1.19422",
  "chatspot-widget-iframe": "static-1.23076",
  "collaboration-sidebar-common": "static-1.3542",
  "marketing-platform-lib": "static-1.7186",
  "calling-global-api": "static-1.65655",
  "calling-internal-common": "static-1.31639",
  "calling-lifecycle-internal": "static-1.67037",
  "calling-lifecycle-messages": "static-1.59331",
  "commerce-products-lib": "static-1.10554",
  "conditional-properties-service-client": "static-1.4025",
  "crm-index-visualization-core": "static-1.4558",
  "crm-links": "static-1.6647",
  "crm-pipelines-api-client-types": "static-1.4358",
  "customer-data-properties-shared-msw-handlers": "static-1.9966",
  "external-options-client-types": "static-1.4349",
  "formula-editor": "static-1.14784",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4437",
  "meetings-icalendar-utils-lib": "static-1.952",
  "multi-currency-client-types": "static-1.3918",
  "object-builder-ui-client": "static-1.49704",
  "pipeline-validation-client-types": "static-1.4191",
  "smart-data-capture-core": "static-1.162",
  "smart-property-lib": "static-1.8322",
  "tiered-pricing": "static-1.1976",
  "topics-actions-lib": "static-1.484",
  "ui-addon-form-validation": "static-1.11299",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.327",
  "framework-data-schema-quick-fetch": "static-1.7113",
  "restore-request-side-panel-lib": "static-1.1700",
  "growth-data-modal": "static-1.5915",
  "growth-onboarding-confetti": "static-1.3378",
  "growth-onboarding-next-action-utils": "static-1.2711",
  "onboarding-tours-utils": "static-1.1199",
  "ui-shepherd-tracker": "static-1.7967",
  "academy-service-client": "static-1.4006",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4720",
  "video-embed": "static-1.36661",
  "cms-field-types": "static-1.5131",
  "content-icons-ui": "static-1.2380",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25020",
  "viral-links-lib": "static-1.7393",
  "nested-table": "static-1.551",
  "timezone-utils": "static-2.5560",
  "getting-started-shared-tasks-store": "static-1.18384",
  "campaign-roi-lib": "static-1.10296",
  "campaigns-utils-lib": "static-1.3535",
  "ui-addon-calendars": "static-2.5652",
  "customer-data-views-management": "static-1.26054",
  "framework-data-table": "static-2.12571",
  "nudge-client-utils": "static-1.3161",
  "nudge-custom-ui-functions": "static-1.1508",
  "switchboard-lib": "static-1.532",
  "access-check-ui-lib": "static-1.1607",
  "app-users-service-client": "static-1.5936",
  "app-users-service-types": "static-1.5344",
  "mini-checkout-client": "static-1.27526",
  "onboarding-utils": "static-1.5685",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29315",
  "checkout-sdk": "static-3.24369",
  "payment-method-components": "static-1.7164",
  "touchless-buying-components": "static-1.6237",
  "upgrade-catalog-service-types": "static-1.3785",
  "edison-service-client-types": "static-1.710",
  "growth-onboarding-feedback-components": "static-1.6901",
  "FileManagerCore": "static-1.40024",
  "FileManagerImages": "static-1.37676",
  "video-components": "static-1.14171",
  "js-cookie": "static-1.18",
  "calling-error-reporting": "static-1.31646",
  "shared-worker-versioning": "static-1.11358",
  "voice-sms-access-library": "static-1.2085",
  "commerce-permissions": "static-1.1093",
  "products-iframe-lib": "static-1.8608",
  "crm-index-associations-lib": "static-1.6758",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10722",
  "sales-views-client-types": "static-1.4572",
  "bark-lib": "static-1.16829",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.665",
  "policy-lib": "static-1.7118",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10785",
  "customer-data-tracking": "static-1.7198",
  "onboarding-data-sync-lib": "static-1.2530",
  "growth-onboarding-next-action-components": "static-1.2739",
  "user-context-client": "static-1.4822",
  "outpost": "static-1.4470",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22174",
  "sales-email-signature-service-client": "static-1.4161",
  "ts-utils-lib": "static-1.466",
  "crm-export-dialog": "static-1.6599",
  "crm-index-ui-shimmer": "static-1.2676",
  "crm-view-components": "static-1.1196",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7645",
  "tasks-actions-lib": "static-1.154",
  "nudge-custom-function-registry": "static-1.2918",
  "nudge-renderer-utils": "static-1.3237",
  "whisper-core-api": "static-1.7349",
  "InboxConnectUtils": "static-4.15580",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46866",
  "hub-http-rxjs": "static-1.847",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4307",
  "company-details-components": "static-1.6520",
  "react-performance-metrics-lib": "static-1.871",
  "pricing-pages-ui-components": "static-1.15859",
  "quote-checkout-service-types": "static-1.3770",
  "audio-components": "static-1.6361",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4849",
  "social-insights-client-types": "static-1.22706",
  "calling-orchestration-schema": "static-1.36862",
  "react-reducer-toolkit": "static-1.16387",
  "meetings-connect-utils-lib": "static-1.7925",
  "hub-http-contrib": "static-1.3356",
  "ui-addon-sales-email": "static-1.5530",
  "access-control-lib": "static-1.10752",
  "EmailComponents": "static-1.55571",
  "EmailData": "static-1.54249",
  "redux-less": "static-2.9794",
  "company-details-service-types": "static-1.4256",
  "segments-query-core": "static-1.1740",
  "pricing-pages-api": "static-1.15724",
  "ContentData": "static-1.69221",
  "marketing-email-service-types": "static-1.2102",
  "messaging-editing-lib": "static-1.47166",
  "messaging-usage-based-billing-components-lib": "static-1.2028",
  "automation-ui-source-apps": "static-1.19702",
  "automation-ui-types": "static-1.20620",
  "messaging-types-lib": "static-1.46903",
  "onboarding-settings-client": "static-1.4825",
  "advanced-menus-core": "static-1.15593",
  "ui-memberships-settings-lib": "static-1.34866",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77935",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4232",
  "web-interactives-components": "static-1.14264",
  "web-interactives-data": "static-1.14265",
  "messaging-shared-utils-lib": "static-1.1477",
  "messaging-user-info-utils-lib": "static-1.1647",
  "email-portal-health-service-types": "static-1.1297",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15592",
  "campaigns-lib": "static-1.27685",
  "content-management-data-lib": "static-1.5977",
  "ContentComponents": "static-2.72102",
  "copilot-plugins": "static-1.11837",
  "cta-picker": "static-1.37105",
  "customer-agent-discovery-components-lib": "static-1.3981",
  "editor-components": "static-1.13665",
  "editor-iframe-lib": "static-1.8814",
  "error-messaging-js": "static-1.5515",
  "FireAlarmUi": "static-1.4732",
  "FormsCommonComponents": "static-1.86580",
  "interframe": "static-3.5071",
  "layout-data-lib": "static-1.10287",
  "layout-dnd-components": "static-1.12987",
  "layout-dnd-utils": "static-1.11962",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10966",
  "SharedLegalStrings": "static-1.2061",
  "smart-content-core": "static-1.43194",
  "smart-content-lib": "static-1.43847",
  "social-composer-lib": "static-1.60321",
  "structured-content-lib": "static-1.25937",
  "theme-previewer-lib": "static-1.53949",
  "tinymce-config": "static-2.55129",
  "tinymce-copilot": "static-1.17197",
  "tinymce-data": "static-1.41214",
  "tinymce-plugins": "static-1.58243",
  "ui-addon-draggable-compat": "static-2.4579",
  "ui-brand-identity-lib": "static-1.16535",
  "xray-recommendation-lib": "static-1.8278",
  "attribution-lib": "static-1.42810",
  "reporting-enablement": "static-1.23853",
  "advanced-menus-lib": "static-1.12467",
  "automation-ui-ubb": "static-1.6536",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7654",
  "data-token-views": "static-1.16888",
  "forms-utils-lib": "static-1.13110",
  "payments-embed-points-lib": "static-1.13608",
  "products-ui-components": "static-1.41072",
  "react-tinymce": "static-1.56003",
  "simple-menus-lib": "static-1.17109",
  "videoconference-integration-components": "static-1.7300",
  "forms-ai-lib": "static-1.4780",
  "ui-gdpr-components": "static-1.10625",
  "codemirror-dlb": "static-1.59494",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57099",
  "commerce-tools-ui-lib": "static-1.11066",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6755",
  "property-description-translator": "static-1.4154",
  "report-customization-components": "static-1.13936",
  "data-quality-ui-library": "static-1.13841",
  "reporting-filters": "static-1.1019",
  "reporting-insights-lib": "static-1.2599",
  "automation-ui-core": "static-2.22556",
  "automation-ui-usage-tracking": "static-1.22019",
  "data-studio-ubb": "static-1.3532",
  "commerce-analytics-service-client": "static-1.3834",
  "payments-enrollment-embed-lib": "static-1.23868",
  "commerce-subscription-lib": "static-1.37806",
  "commerce-tax-lib": "static-1.856",
  "crm_data": "static-4.92855",
  "price-books-api": "static-1.1756",
  "price-books-components": "static-1.1814",
  "ramp-editor": "static-1.910",
  "NamespacedHubStyle": "static-2.9274",
  "customer-data-rte": "static-1.33667",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6295",
  "payments-post-enroll-local-storage-lib": "static-1.5421",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38940",
  "merge-modal-lib": "static-1.12597",
  "segments-client-types": "static-1.11604",
  "automation-ui-routing": "static-1.21977",
  "sql-reporting-client-types": "static-1.5905",
  "commerce-billing-lib": "static-1.20213",
  "commerce-shared-components-lib": "static-1.19241",
  "crm_universal": "static-1.22512",
  "customer-data-email": "static-1.18541",
  "line-items-api": "static-1.1112",
  "draft-content-plugins": "static-1.28924",
  "utility-belt": "static-1.2848",
  "stripe-embedded-components": "static-1.8013",
  "sequences-lib": "static-1.8547",
  "react-immutable-render-mixin": "static-1.9",
  "stripe-connect-js": "static-1.77",
  "sequences-client-types-lib": "static-1.8404"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13262",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.815",
  "client-types": "/client-types/static-1.498",
  "data-fetching-client": "/data-fetching-client/static-1.9973",
  "foundations-components": "/foundations-components/static-1.8513",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1538",
  "foundations-theming": "/foundations-theming/static-1.4791",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8349",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10639",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11805",
  "I18n": "/I18n/static-7.1676",
  "jasmine-runner": "/jasmine-runner/static-1.6767",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.655",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13325",
  "quartz": "/quartz/static-1.7475",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1.17037",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3172",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10795",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12841",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7644",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11463",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9851",
  "unified-auth": "/unified-auth/static-1.938",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1220",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8418",
  "hub-http": "/hub-http/static-1.6530",
  "integrations-lib": "/integrations-lib/static-1.17066",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20758",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.744",
  "property-management-iframe": "/property-management-iframe/static-1.14154",
  "quartz-config": "/quartz-config/static-1.1253",
  "quartz-core": "/quartz-core/static-1.6694",
  "quartz-routing": "/quartz-routing/static-1.905",
  "quick-fetch": "/quick-fetch/static-1.4139",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.4982",
  "ts-schema": "/ts-schema/static-1.4304",
  "ui-universal-auth": "/ui-universal-auth/static-1.9424",
  "UIComponents": "/UIComponents/static-3.8751",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3631",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3752",
  "quartz-webpack": "/quartz-webpack/static-1.3699",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.553",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9744",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5201",
  "pulse": "/pulse/static-1.945",
  "react-codemirror": "/react-codemirror/static-1.10957",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.628",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4782",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2507",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9740",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.73",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5566",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.503",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2678",
  "ui-fonts": "/ui-fonts/static-1.1067",
  "ui-images": "/ui-images/static-2.1252",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3274",
  "foundations-theming-base": "/foundations-theming-base/static-1.3776",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.798",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3460",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4629",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9020",
  "ai-rendering-library": "/ai-rendering-library/static-1.11118",
  "chirp-fetch": "/chirp-fetch/static-1.2212",
  "connections-embed-lib": "/connections-embed-lib/static-1.1529",
  "copilot-toolkit": "/copilot-toolkit/static-1.11865",
  "feedback-loader": "/feedback-loader/static-1.29829",
  "laboratory-lib": "/laboratory-lib/static-3.7470",
  "marketplace-embed": "/marketplace-embed/static-1.22939",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10653",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20713",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14928",
  "sanitize-text": "/sanitize-text/static-1.8472",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7210",
  "quartz-head": "/quartz-head/static-1.1140",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4972",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4464",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2699",
  "reporting-data": "/reporting-data/static-1.68862",
  "cssUtils": "/cssUtils/static-1.938",
  "flux-actions": "/flux-actions/static-1.369",
  "react-colorpicker": "/react-colorpicker/static-2.10533",
  "react-dnd-compat": "/react-dnd-compat/static-1.4932",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10687",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.685",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19290",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4825",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5996",
  "quartz-i18n": "/quartz-i18n/static-1.1150",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.484",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1450",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.66",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1052",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.168",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.510",
  "slack-ui-library": "/slack-ui-library/static-1.10714",
  "fsm": "/fsm/static-1.4066",
  "customer-data-objects": "/customer-data-objects/static-1.8009",
  "property-translator": "/property-translator/static-1.5711",
  "hs-locale-management": "/hs-locale-management/static-1.304",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8238",
  "hs-promise-utils": "/hs-promise-utils/static-1.5911",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5194",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14481",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5925",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8093",
  "sanitize": "/sanitize/static-1.4788",
  "superstore": "/superstore/static-1.5074",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10586",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8363",
  "hub-http-janus": "/hub-http-janus/static-1.883",
  "hubspotter-http": "/hubspotter-http/static-1.4872",
  "immutable-less": "/immutable-less/static-1.4966",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18165",
  "nav-meta": "/nav-meta/static-1.30497",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18401",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1102",
  "ai-studio-lib": "/ai-studio-lib/static-1.12453",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18991",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.502",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9394",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8343",
  "ui-product-approvals": "/ui-product-approvals/static-1.29207",
  "ui-tool-access": "/ui-tool-access/static-1.10470",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4064",
  "property-management-common": "/property-management-common/static-1.6442",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.87",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.578",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.462",
  "quartz-auth": "/quartz-auth/static-1.1150",
  "quartz-test": "/quartz-test/static-1.1150",
  "quartz-tracking": "/quartz-tracking/static-1.854",
  "trellis-components": "/trellis-components/static-1.2697",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.392",
  "HubStyle": "/HubStyle/static-2.12112",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "chatspot-core": "/chatspot-core/static-1.23085",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13346",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.448",
  "batch-promise": "/batch-promise/static-1.1861",
  "event-emitter": "/event-emitter/static-1.1269",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5769",
  "magpie-types": "/magpie-types/static-1.5229",
  "stylex-utils": "/stylex-utils/static-1.143",
  "trellis-theming": "/trellis-theming/static-1.1290",
  "avatar-components": "/avatar-components/static-1.2798",
  "breeze-engine-core": "/breeze-engine-core/static-1.1051",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.755",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40966",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13494",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15555",
  "ExportDialog": "/ExportDialog/static-6.10694",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.162",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.642",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42074",
  "reporting-snowflake": "/reporting-snowflake/static-1.57479",
  "reporting-ui-components": "/reporting-ui-components/static-2.66132",
  "reporting-visualizations": "/reporting-visualizations/static-1.60937",
  "trial-components-library": "/trial-components-library/static-1.14125",
  "ui-addon-teams": "/ui-addon-teams/static-1.21923",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.536",
  "navigation-components": "/navigation-components/static-1.18860",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1773",
  "simple-logging-lib": "/simple-logging-lib/static-1.3368",
  "fail-safe": "/fail-safe/static-1.270",
  "app-governance-lib": "/app-governance-lib/static-1.2414",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10856",
  "purchase-motions-components": "/purchase-motions-components/static-1.6381",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10296",
  "autolinker": "/autolinker/static-3.11",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4018",
  "reference-resolvers": "/reference-resolvers/static-1.8497",
  "sassPrefix": "/sassPrefix/static-1.207",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4234",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.653",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3325",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3542",
  "atom": "/atom/static-1.5403",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "salesImages": "/salesImages/static-1.579",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5076",
  "content-assistance-lib": "/content-assistance-lib/static-1.8216",
  "content-media-capture": "/content-media-capture/static-1.5465",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10148",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24525",
  "growth-payments-core": "/growth-payments-core/static-1.26207",
  "knowledge-content-types": "/knowledge-content-types/static-1.8660",
  "PatternValidationJS": "/PatternValidationJS/static-1.3209",
  "payment-link-components": "/payment-link-components/static-1.24192",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20323",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10201",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9406",
  "video-components-external": "/video-components-external/static-1.12169",
  "video-data-lib": "/video-data-lib/static-1.35827",
  "navigation-messaging": "/navigation-messaging/static-1.8187",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58745",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6206",
  "customer-data-properties": "/customer-data-properties/static-1.52634",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7208",
  "property-value-citations": "/property-value-citations/static-1.3248",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8419",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10637",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1034",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.381",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.943",
  "onboarding-scopes": "/onboarding-scopes/static-1.6768",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7564",
  "crm-message-bus": "/crm-message-bus/static-1.43787",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23401",
  "events-data-lib": "/events-data-lib/static-1.563",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5043",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4231",
  "hs-resources": "/hs-resources/static-1.507",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1322",
  "onboarding-tours": "/onboarding-tours/static-1.17132",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14488",
  "academy-common-lib": "/academy-common-lib/static-1.15015",
  "ContentUtils": "/ContentUtils/static-1.69146",
  "dashboard-lib": "/dashboard-lib/static-1.82873",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19266",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18983",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9023",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11414",
  "user-context": "/user-context/static-1.5436",
  "reporting-plugins": "/reporting-plugins/static-1.10769",
  "reporting-reports": "/reporting-reports/static-1.68539",
  "hubs-service-types": "/hubs-service-types/static-1.1576",
  "purchase-motions-api": "/purchase-motions-api/static-1.6384",
  "signup-constants": "/signup-constants/static-1.19649",
  "nest": "/nest/static-1.552",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.751",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.221",
  "framework-listing-lib": "/framework-listing-lib/static-2.29519",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31460",
  "apps-service-types": "/apps-service-types/static-1.4056",
  "oauth-service-types": "/oauth-service-types/static-1.4552",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8377",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5347",
  "one-click-checkout": "/one-click-checkout/static-1.431",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7902",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15256",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10121",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29330",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4742",
  "seat-types-lib": "/seat-types-lib/static-1.754",
  "ui-addon-opt": "/ui-addon-opt/static-4.8680",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6636",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5397",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3846",
  "data-token-picker": "/data-token-picker/static-1.16907",
  "FileManagerLib": "/FileManagerLib/static-1.40165",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13269",
  "content-media-compositions": "/content-media-compositions/static-2.17276",
  "media-bridge-lib": "/media-bridge-lib/static-1.19422",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23076",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3542",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7186",
  "calling-global-api": "/calling-global-api/static-1.65655",
  "calling-internal-common": "/calling-internal-common/static-1.31639",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67037",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59331",
  "commerce-products-lib": "/commerce-products-lib/static-1.10554",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4025",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4558",
  "crm-links": "/crm-links/static-1.6647",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4358",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9966",
  "external-options-client-types": "/external-options-client-types/static-1.4349",
  "formula-editor": "/formula-editor/static-1.14784",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4437",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.952",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3918",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49704",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4191",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.162",
  "smart-property-lib": "/smart-property-lib/static-1.8322",
  "tiered-pricing": "/tiered-pricing/static-1.1976",
  "topics-actions-lib": "/topics-actions-lib/static-1.484",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11299",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.327",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7113",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1700",
  "growth-data-modal": "/growth-data-modal/static-1.5915",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3378",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2711",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1199",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7967",
  "academy-service-client": "/academy-service-client/static-1.4006",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4720",
  "video-embed": "/video-embed/static-1.36661",
  "cms-field-types": "/cms-field-types/static-1.5131",
  "content-icons-ui": "/content-icons-ui/static-1.2380",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25020",
  "viral-links-lib": "/viral-links-lib/static-1.7393",
  "nested-table": "/nested-table/static-1.551",
  "timezone-utils": "/timezone-utils/static-2.5560",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18384",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10296",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3535",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5652",
  "customer-data-views-management": "/customer-data-views-management/static-1.26054",
  "framework-data-table": "/framework-data-table/static-2.12571",
  "nudge-client-utils": "/nudge-client-utils/static-1.3161",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1508",
  "switchboard-lib": "/switchboard-lib/static-1.532",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1607",
  "app-users-service-client": "/app-users-service-client/static-1.5936",
  "app-users-service-types": "/app-users-service-types/static-1.5344",
  "mini-checkout-client": "/mini-checkout-client/static-1.27526",
  "onboarding-utils": "/onboarding-utils/static-1.5685",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29315",
  "checkout-sdk": "/checkout-sdk/static-3.24369",
  "payment-method-components": "/payment-method-components/static-1.7164",
  "touchless-buying-components": "/touchless-buying-components/static-1.6237",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3785",
  "edison-service-client-types": "/edison-service-client-types/static-1.710",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6901",
  "FileManagerCore": "/FileManagerCore/static-1.40024",
  "FileManagerImages": "/FileManagerImages/static-1.37676",
  "video-components": "/video-components/static-1.14171",
  "js-cookie": "/js-cookie/static-1.18",
  "calling-error-reporting": "/calling-error-reporting/static-1.31646",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11358",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2085",
  "commerce-permissions": "/commerce-permissions/static-1.1093",
  "products-iframe-lib": "/products-iframe-lib/static-1.8608",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6758",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10722",
  "sales-views-client-types": "/sales-views-client-types/static-1.4572",
  "bark-lib": "/bark-lib/static-1.16829",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.665",
  "policy-lib": "/policy-lib/static-1.7118",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10785",
  "customer-data-tracking": "/customer-data-tracking/static-1.7198",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2530",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2739",
  "user-context-client": "/user-context-client/static-1.4822",
  "outpost": "/outpost/static-1.4470",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22174",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4161",
  "ts-utils-lib": "/ts-utils-lib/static-1.466",
  "crm-export-dialog": "/crm-export-dialog/static-1.6599",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2676",
  "crm-view-components": "/crm-view-components/static-1.1196",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7645",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.154",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2918",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3237",
  "whisper-core-api": "/whisper-core-api/static-1.7349",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15580",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46866",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.847",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4307",
  "company-details-components": "/company-details-components/static-1.6520",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.871",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15859",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3770",
  "audio-components": "/audio-components/static-1.6361",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4849",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36862",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16387",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7925",
  "hub-http-contrib": "/hub-http-contrib/static-1.3356",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5530",
  "access-control-lib": "/access-control-lib/static-1.10752",
  "EmailComponents": "/EmailComponents/static-1.55571",
  "EmailData": "/EmailData/static-1.54249",
  "redux-less": "/redux-less/static-2.9794",
  "company-details-service-types": "/company-details-service-types/static-1.4256",
  "segments-query-core": "/segments-query-core/static-1.1740",
  "pricing-pages-api": "/pricing-pages-api/static-1.15724",
  "ContentData": "/ContentData/static-1.69221",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2102",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47166",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2028",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19702",
  "automation-ui-types": "/automation-ui-types/static-1.20620",
  "messaging-types-lib": "/messaging-types-lib/static-1.46903",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4825",
  "advanced-menus-core": "/advanced-menus-core/static-1.15593",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34866",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77935",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4232",
  "web-interactives-components": "/web-interactives-components/static-1.14264",
  "web-interactives-data": "/web-interactives-data/static-1.14265",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1477",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1647",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1297",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15592",
  "campaigns-lib": "/campaigns-lib/static-1.27685",
  "content-management-data-lib": "/content-management-data-lib/static-1.5977",
  "ContentComponents": "/ContentComponents/static-2.72102",
  "copilot-plugins": "/copilot-plugins/static-1.11837",
  "cta-picker": "/cta-picker/static-1.37105",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3981",
  "editor-components": "/editor-components/static-1.13665",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8814",
  "error-messaging-js": "/error-messaging-js/static-1.5515",
  "FireAlarmUi": "/FireAlarmUi/static-1.4732",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86580",
  "interframe": "/interframe/static-3.5071",
  "layout-data-lib": "/layout-data-lib/static-1.10287",
  "layout-dnd-components": "/layout-dnd-components/static-1.12987",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11962",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10966",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2061",
  "smart-content-core": "/smart-content-core/static-1.43194",
  "smart-content-lib": "/smart-content-lib/static-1.43847",
  "social-composer-lib": "/social-composer-lib/static-1.60321",
  "structured-content-lib": "/structured-content-lib/static-1.25937",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53949",
  "tinymce-config": "/tinymce-config/static-2.55129",
  "tinymce-copilot": "/tinymce-copilot/static-1.17197",
  "tinymce-data": "/tinymce-data/static-1.41214",
  "tinymce-plugins": "/tinymce-plugins/static-1.58243",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4579",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16535",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8278",
  "attribution-lib": "/attribution-lib/static-1.42810",
  "reporting-enablement": "/reporting-enablement/static-1.23853",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12467",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6536",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7654",
  "data-token-views": "/data-token-views/static-1.16888",
  "forms-utils-lib": "/forms-utils-lib/static-1.13110",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13608",
  "products-ui-components": "/products-ui-components/static-1.41072",
  "react-tinymce": "/react-tinymce/static-1.56003",
  "simple-menus-lib": "/simple-menus-lib/static-1.17109",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7300",
  "forms-ai-lib": "/forms-ai-lib/static-1.4780",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "codemirror-dlb": "/codemirror-dlb/static-1.59494",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57099",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11066",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6755",
  "property-description-translator": "/property-description-translator/static-1.4154",
  "report-customization-components": "/report-customization-components/static-1.13936",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13841",
  "reporting-filters": "/reporting-filters/static-1.1019",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2599",
  "automation-ui-core": "/automation-ui-core/static-2.22556",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22019",
  "data-studio-ubb": "/data-studio-ubb/static-1.3532",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3834",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23868",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37806",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.856",
  "crm_data": "/crm_data/static-4.92855",
  "price-books-api": "/price-books-api/static-1.1756",
  "price-books-components": "/price-books-components/static-1.1814",
  "ramp-editor": "/ramp-editor/static-1.910",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9274",
  "customer-data-rte": "/customer-data-rte/static-1.33667",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6295",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5421",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38940",
  "merge-modal-lib": "/merge-modal-lib/static-1.12597",
  "segments-client-types": "/segments-client-types/static-1.11604",
  "automation-ui-routing": "/automation-ui-routing/static-1.21977",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5905",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20213",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19241",
  "crm_universal": "/crm_universal/static-1.22512",
  "customer-data-email": "/customer-data-email/static-1.18541",
  "line-items-api": "/line-items-api/static-1.1112",
  "draft-content-plugins": "/draft-content-plugins/static-1.28924",
  "utility-belt": "/utility-belt/static-1.2848",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8013",
  "sequences-lib": "/sequences-lib/static-1.8547",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "stripe-connect-js": "/stripe-connect-js/static-1.77",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8404"
}
};
